import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";

import { USER_LOGOUT } from "../actions/user";
import app from "./app";
import adPlacementsModal from "./ad_placements_modal";
import balance from "./balance";
import { shows, episodesByShow, mediaFiles } from "./shows";
import deals from "./deals";
import mediaFileUpload from "./media_file_upload";
import modal from "./modal";
import signIn from "./sign_in";
import episodeDelete from "./episode_delete";
import { signOut, updateAccount } from "./account";
import showForm from "./show_form";
import signUp from "./sign_up";
import stats from "./stats";
import transactions from "./transactions";
import user from "./user";
import { ads, putAds } from "./ads";
import { targetingRules, putTargetingRules } from "./targeting_rules";
import stripeConnect from "./stripe_connect";
import { emailVerification, sendVerificationEmail } from "./email_verification";
import statsOptions from "./stats_options";
import directoryShows from "./directory_shows";
import { showFeedImport, episodeFeedImport } from "./feed_import";
import { forgotPassword, recoverPassword } from "./forgot_password";
import messages from "./messages";
import distributions from "./distributions";
import publicShows from "./public_show";
import browsePromotion from "./browse_promotion";
import budgets from "./budgets";
import imageUploader from "./image-uploader";
import advertiserSignUp from "./advertiser_contacts";
import subscriptions from "./subscriptions";
import payments from "./payment";
import audioBlocks from "./audio_blocks";
import markers from "./markers";
import episodes from "./episodes";
import youtube from "./youtube";
import scheduledJobs from "./scheduled_jobs";
import campaignItems from "./campaign-items";
import campaigns from "./campaigns";
export function removeItem(array, item) {
  var index = array.indexOf(item);
  var copy = [...array];
  if (index !== -1) copy.splice(index, 1);
  return copy;
}

const mainReducer = combineReducers({
  // The redux chrome extension lists these reducers in the
  // order they are defined here, so let's keep them in alpha order.
  adPlacementsModal,
  advertiserSignUp,
  ads,
  app,
  audioBlocks,
  balance,
  browsePromotion,
  budgets,
  campaignItems,
  campaigns,
  deals,
  directoryShows,
  distributions,
  emailVerification,
  episodeDelete,
  episodeFeedImport,
  episodes,
  episodesByShow,
  forgotPassword,
  form: formReducer,
  imageUploader,
  markers,
  mediaFiles,
  mediaFileUpload,
  messages,
  modal,
  payments,
  publicShows,
  putAds,
  putTargetingRules,
  recoverPassword,
  scheduledJobs,
  sendVerificationEmail,
  showFeedImport,
  showForm,
  shows,
  signIn,
  signOut,
  signUp,
  stats,
  statsOptions,
  stripeConnect,
  subscriptions,
  targetingRules,
  transactions,
  youtube,
  updateAccount,
  user,
});

// Handles clearing all state on logout.
const rootReducer = (state, action) => {
  if (action.type === USER_LOGOUT) {
    state = undefined;
  }
  return mainReducer(state, action);
};

export default rootReducer;
